const materialColors = {
  red: {
    '50': { material: '#FFEBEE', text: 'Dark' },
    '100': { material: '#FFCDD2', text: 'Dark' },
    '200': { material: '#EF9A9A', text: 'Dark' },
    '300': { material: '#E57373', text: 'Dark' },
    '400': { material: '#EF5350', text: 'Light' },
    '500': { material: '#F44336', text: 'Light' },
    '600': { material: '#E53935', text: 'Light' },
    '700': { material: '#D32F2F', text: 'Light' },
    '800': { material: '#C62828', text: 'Light' },
    '900': { material: '#B71C1C', text: 'Light' },
    A100: { material: '#FF8A80', text: 'Dark' },
    A200: { material: '#FF5252', text: 'Light' },
    A400: { material: '#FF1744', text: 'Light' },
    A700: { material: '#D50000', text: 'Light' }
  },
  pink: {
    '50': { material: '#FCE4EC', text: 'Dark' },
    '100': { material: '#F8BBD0', text: 'Dark' },
    '200': { material: '#F48FB1', text: 'Dark' },
    '300': { material: '#F06292', text: 'Light' },
    '400': { material: '#EC407A', text: 'Light' },
    '500': { material: '#E91E63', text: 'Light' },
    '600': { material: '#D81B60', text: 'Light' },
    '700': { material: '#C2185B', text: 'Light' },
    '800': { material: '#AD1457', text: 'Light' },
    '900': { material: '#880E4F', text: 'Light' },
    A100: { material: '#FF80AB', text: 'Dark' },
    A200: { material: '#FF4081', text: 'Light' },
    A400: { material: '#F50057', text: 'Light' },
    A700: { material: '#C51162', text: 'Light' }
  },
  purple: {
    '50': { material: '#F3E5F5', text: 'Dark' },
    '100': { material: '#E1BEE7', text: 'Dark' },
    '200': { material: '#CE93D8', text: 'Dark' },
    '300': { material: '#BA68C8', text: 'Light' },
    '400': { material: '#AB47BC', text: 'Light' },
    '500': { material: '#9C27B0', text: 'Light' },
    '600': { material: '#8E24AA', text: 'Light' },
    '700': { material: '#7B1FA2', text: 'Light' },
    '800': { material: '#6A1B9A', text: 'Light' },
    '900': { material: '#4A148C', text: 'Light' },
    A100: { material: '#EA80FC', text: 'Dark' },
    A200: { material: '#E040FB', text: 'Light' },
    A400: { material: '#D500F9', text: 'Light' },
    A700: { material: '#AA00FF', text: 'Light' }
  },
  deepPurple: {
    '50': { material: '#EDE7F6', text: 'Dark' },
    '100': { material: '#D1C4E9', text: 'Dark' },
    '200': { material: '#B39DDB', text: 'Dark' },
    '300': { material: '#9575CD', text: 'Light' },
    '400': { material: '#7E57C2', text: 'Light' },
    '500': { material: '#673AB7', text: 'Light' },
    '600': { material: '#5E35B1', text: 'Light' },
    '700': { material: '#512DA8', text: 'Light' },
    '800': { material: '#4527A0', text: 'Light' },
    '900': { material: '#311B92', text: 'Light' },
    A100: { material: '#B388FF', text: 'Dark' },
    A200: { material: '#7C4DFF', text: 'Light' },
    A400: { material: '#651FFF', text: 'Light' },
    A700: { material: '#6200EA', text: 'Light' }
  },
  indigo: {
    '50': { material: '#E8EAF6', text: 'Dark' },
    '100': { material: '#C5CAE9', text: 'Dark' },
    '200': { material: '#9FA8DA', text: 'Dark' },
    '300': { material: '#7986CB', text: 'Light' },
    '400': { material: '#5C6BC0', text: 'Light' },
    '500': { material: '#3F51B5', text: 'Light' },
    '600': { material: '#3949AB', text: 'Light' },
    '700': { material: '#303F9F', text: 'Light' },
    '800': { material: '#283593', text: 'Light' },
    '900': { material: '#1A237E', text: 'Light' },
    A100: { material: '#8C9EFF', text: 'Dark' },
    A200: { material: '#536DFE', text: 'Light' },
    A400: { material: '#3D5AFE', text: 'Light' },
    A700: { material: '#304FFE', text: 'Light' }
  },
  blue: {
    '50': { material: '#E3F2FD', text: 'Dark' },
    '100': { material: '#BBDEFB', text: 'Dark' },
    '200': { material: '#90CAF9', text: 'Dark' },
    '300': { material: '#64B5F6', text: 'Dark' },
    '400': { material: '#42A5F5', text: 'Dark' },
    '500': { material: '#2196F3', text: 'Light' },
    '600': { material: '#1E88E5', text: 'Light' },
    '700': { material: '#1976D2', text: 'Light' },
    '800': { material: '#1565C0', text: 'Light' },
    '900': { material: '#0D47A1', text: 'Light' },
    A100: { material: '#82B1FF', text: 'Dark' },
    A200: { material: '#448AFF', text: 'Light' },
    A400: { material: '#2979FF', text: 'Light' },
    A700: { material: '#2962FF', text: 'Light' }
  },
  lightBlue: {
    '50': { material: '#E1F5FE', text: 'Dark' },
    '100': { material: '#B3E5FC', text: 'Dark' },
    '200': { material: '#81D4FA', text: 'Dark' },
    '300': { material: '#4FC3F7', text: 'Dark' },
    '400': { material: '#29B6F6', text: 'Dark' },
    '500': { material: '#03A9F4', text: 'Dark' },
    '600': { material: '#039BE5', text: 'Light' },
    '700': { material: '#0288D1', text: 'Light' },
    '800': { material: '#0277BD', text: 'Light' },
    '900': { material: '#01579B', text: 'Light' },
    A100: { material: '#80D8FF', text: 'Dark' },
    A200: { material: '#40C4FF', text: 'Dark' },
    A400: { material: '#00B0FF', text: 'Dark' },
    A700: { material: '#0091EA', text: 'Light' }
  },
  cyan: {
    '50': { material: '#E0F7FA', text: 'Dark' },
    '100': { material: '#B2EBF2', text: 'Dark' },
    '200': { material: '#80DEEA', text: 'Dark' },
    '300': { material: '#4DD0E1', text: 'Dark' },
    '400': { material: '#26C6DA', text: 'Dark' },
    '500': { material: '#00BCD4', text: 'Dark' },
    '600': { material: '#00ACC1', text: 'Dark' },
    '700': { material: '#0097A7', text: 'Light' },
    '800': { material: '#00838F', text: 'Light' },
    '900': { material: '#006064', text: 'Light' },
    A100: { material: '#84FFFF', text: 'Dark' },
    A200: { material: '#18FFFF', text: 'Dark' },
    A400: { material: '#00E5FF', text: 'Dark' },
    A700: { material: '#00B8D4', text: 'Dark' }
  },
  coursio: {
    '50': { material: '#70FDFF', text: 'Dark' },
    '100': { material: '#5CFCFF', text: 'Dark' },
    '200': { material: '#47FCFF', text: 'Dark' },
    '300': { material: '#1FFBFF', text: 'Dark' },
    '400': { material: '#00F1F5', text: 'Dark' },
    '500': { material: '#00c9cc', text: 'Light' },
    '600': { material: '#00A0A3', text: 'Light' },
    '700': { material: '#008C8F', text: 'Light' },
    '800': { material: '#006466', text: 'Light' },
    '900': { material: '#003C3D', text: 'Light' },
    A100: { material: '#5CFCFF', text: 'Dark' },
    A200: { material: '#47FCFF', text: 'Dark' },
    A400: { material: '#00F1F5', text: 'Dark' },
    A700: { material: '#008C8F', text: 'Dark' }
  },
  teal: {
    '50': { material: '#E0F2F1', text: 'Dark' },
    '100': { material: '#B2DFDB', text: 'Dark' },
    '200': { material: '#80CBC4', text: 'Dark' },
    '300': { material: '#4DB6AC', text: 'Dark' },
    '400': { material: '#26A69A', text: 'Dark' },
    '500': { material: '#009688', text: 'Light' },
    '600': { material: '#00897B', text: 'Light' },
    '700': { material: '#00796B', text: 'Light' },
    '800': { material: '#00695C', text: 'Light' },
    '900': { material: '#004D40', text: 'Light' },
    A100: { material: '#A7FFEB', text: 'Dark' },
    A200: { material: '#64FFDA', text: 'Dark' },
    A400: { material: '#1DE9B6', text: 'Dark' },
    A700: { material: '#00BFA5', text: 'Dark' }
  },
  green: {
    '50': { material: '#E8F5E9', text: 'Dark' },
    '100': { material: '#C8E6C9', text: 'Dark' },
    '200': { material: '#A5D6A7', text: 'Dark' },
    '300': { material: '#81C784', text: 'Dark' },
    '400': { material: '#66BB6A', text: 'Dark' },
    '500': { material: '#4CAF50', text: 'Dark' },
    '600': { material: '#43A047', text: 'Light' },
    '700': { material: '#388E3C', text: 'Light' },
    '800': { material: '#2E7D32', text: 'Light' },
    '900': { material: '#1B5E20', text: 'Light' },
    A100: { material: '#B9F6CA', text: 'Dark' },
    A200: { material: '#69F0AE', text: 'Dark' },
    A400: { material: '#00E676', text: 'Dark' },
    A700: { material: '#00C853', text: 'Dark' }
  },
  lightGreen: {
    '50': { material: '#F1F8E9', text: 'Dark' },
    '100': { material: '#DCEDC8', text: 'Dark' },
    '200': { material: '#C5E1A5', text: 'Dark' },
    '300': { material: '#AED581', text: 'Dark' },
    '400': { material: '#9CCC65', text: 'Dark' },
    '500': { material: '#8BC34A', text: 'Dark' },
    '600': { material: '#7CB342', text: 'Dark' },
    '700': { material: '#689F38', text: 'Light' },
    '800': { material: '#558B2F', text: 'Light' },
    '900': { material: '#33691E', text: 'Light' },
    A100: { material: '#CCFF90', text: 'Dark' },
    A200: { material: '#B2FF59', text: 'Dark' },
    A400: { material: '#76FF03', text: 'Dark' },
    A700: { material: '#64DD17', text: 'Dark' }
  },
  lime: {
    '50': { material: '#F9FBE7', text: 'Dark' },
    '100': { material: '#F0F4C3', text: 'Dark' },
    '200': { material: '#E6EE9C', text: 'Dark' },
    '300': { material: '#DCE775', text: 'Dark' },
    '400': { material: '#D4E157', text: 'Dark' },
    '500': { material: '#CDDC39', text: 'Dark' },
    '600': { material: '#C0CA33', text: 'Dark' },
    '700': { material: '#AFB42B', text: 'Dark' },
    '800': { material: '#9E9D24', text: 'Dark' },
    '900': { material: '#827717', text: 'Light' },
    A100: { material: '#F4FF81', text: 'Dark' },
    A200: { material: '#EEFF41', text: 'Dark' },
    A400: { material: '#C6FF00', text: 'Dark' },
    A700: { material: '#AEEA00', text: 'Dark' }
  },
  yellow: {
    '50': { material: '#FFFDE7', text: 'Dark' },
    '100': { material: '#FFF9C4', text: 'Dark' },
    '200': { material: '#FFF59D', text: 'Dark' },
    '300': { material: '#FFF176', text: 'Dark' },
    '400': { material: '#FFEE58', text: 'Dark' },
    '500': { material: '#FFEB3B', text: 'Dark' },
    '600': { material: '#FDD835', text: 'Dark' },
    '700': { material: '#FBC02D', text: 'Dark' },
    '800': { material: '#F9A825', text: 'Dark' },
    '900': { material: '#F57F17', text: 'Dark' },
    A100: { material: '#FFFF8D', text: 'Dark' },
    A200: { material: '#FFFF00', text: 'Dark' },
    A400: { material: '#FFEA00', text: 'Dark' },
    A700: { material: '#FFD600', text: 'Dark' }
  },
  amber: {
    '50': { material: '#FFF8E1', text: 'Dark' },
    '100': { material: '#FFECB3', text: 'Dark' },
    '200': { material: '#FFE082', text: 'Dark' },
    '300': { material: '#FFD54F', text: 'Dark' },
    '400': { material: '#FFCA28', text: 'Dark' },
    '500': { material: '#FFC107', text: 'Dark' },
    '600': { material: '#FFB300', text: 'Dark' },
    '700': { material: '#FFA000', text: 'Dark' },
    '800': { material: '#FF8F00', text: 'Dark' },
    '900': { material: '#FF6F00', text: 'Dark' },
    A100: { material: '#FFE57F', text: 'Dark' },
    A200: { material: '#FFD740', text: 'Dark' },
    A400: { material: '#FFC400', text: 'Dark' },
    A700: { material: '#FFAB00', text: 'Dark' }
  },
  orange: {
    '50': { material: '#FFF3E0', text: 'Dark' },
    '100': { material: '#FFE0B2', text: 'Dark' },
    '200': { material: '#FFCC80', text: 'Dark' },
    '300': { material: '#FFB74D', text: 'Dark' },
    '400': { material: '#FFA726', text: 'Dark' },
    '500': { material: '#FF9800', text: 'Dark' },
    '600': { material: '#FB8C00', text: 'Dark' },
    '700': { material: '#F57C00', text: 'Dark' },
    '800': { material: '#EF6C00', text: 'Light' },
    '900': { material: '#E65100', text: 'Light' },
    A100: { material: '#FFD180', text: 'Dark' },
    A200: { material: '#FFAB40', text: 'Dark' },
    A400: { material: '#FF9100', text: 'Dark' },
    A700: { material: '#FF6D00', text: 'Dark' }
  },
  deepOrange: {
    '50': { material: '#FBE9E7', text: 'Dark' },
    '100': { material: '#FFCCBC', text: 'Dark' },
    '200': { material: '#FFAB91', text: 'Dark' },
    '300': { material: '#FF8A65', text: 'Dark' },
    '400': { material: '#FF7043', text: 'Dark' },
    '500': { material: '#FF5722', text: 'Light' },
    '600': { material: '#F4511E', text: 'Light' },
    '700': { material: '#E64A19', text: 'Light' },
    '800': { material: '#D84315', text: 'Light' },
    '900': { material: '#BF360C', text: 'Light' },
    A100: { material: '#FF9E80', text: 'Dark' },
    A200: { material: '#FF6E40', text: 'Dark' },
    A400: { material: '#FF3D00', text: 'Light' },
    A700: { material: '#DD2C00', text: 'Light' }
  },
  brown: {
    '50': { material: '#EFEBE9', text: 'Dark' },
    '100': { material: '#D7CCC8', text: 'Dark' },
    '200': { material: '#BCAAA4', text: 'Dark' },
    '300': { material: '#A1887F', text: 'Light' },
    '400': { material: '#8D6E63', text: 'Light' },
    '500': { material: '#795548', text: 'Light' },
    '600': { material: '#6D4C41', text: 'Light' },
    '700': { material: '#5D4037', text: 'Light' },
    '800': { material: '#4E342E', text: 'Light' },
    '900': { material: '#3E2723', text: 'Light' }
  },
  grey: {
    '50': { material: '#FAFAFA', text: 'Dark' },
    '100': { material: '#F5F5F5', text: 'Dark' },
    '200': { material: '#EEEEEE', text: 'Dark' },
    '300': { material: '#E0E0E0', text: 'Dark' },
    '400': { material: '#BDBDBD', text: 'Dark' },
    '500': { material: '#9E9E9E', text: 'Dark' },
    '600': { material: '#757575', text: 'Light' },
    '700': { material: '#616161', text: 'Light' },
    '800': { material: '#424242', text: 'Light' },
    '900': { material: '#212121', text: 'Light' }
  },
  blueGrey: {
    '50': { material: '#ECEFF1', text: 'Dark' },
    '100': { material: '#CFD8DC', text: 'Dark' },
    '200': { material: '#B0BEC5', text: 'Dark' },
    '300': { material: '#90A4AE', text: 'Dark' },
    '400': { material: '#78909C', text: 'Light' },
    '500': { material: '#607D8B', text: 'Light' },
    '600': { material: '#546E7A', text: 'Light' },
    '700': { material: '#455A64', text: 'Light' },
    '800': { material: '#37474F', text: 'Light' },
    '900': { material: '#263238', text: 'Light' }
  },
  black: '#000000',
  white: '#ffffff',

  transparent: 'rgba(0, 0, 0, 0)',
  fullBlack: 'rgba(0, 0, 0, 1)',
  darkBlack: 'rgba(0, 0, 0, 0.87)',
  lightBlack: 'rgba(0, 0, 0, 0.54)',
  minBlack: 'rgba(0, 0, 0, 0.26)',
  faintBlack: 'rgba(0, 0, 0, 0.12)',
  fullWhite: 'rgba(255, 255, 255, 1)',
  darkWhite: 'rgba(255, 255, 255, 0.87)',
  lightWhite: 'rgba(255, 255, 255, 0.54)',
  bondiBlue: '#00C9CC',
  darkBondiBlue: '#004F51',
  bondiBluehover: '#09E4E9'
};

const textColors = {
  Light: {
    divider: 'rgba(255, 255, 255, 0.12)',
    disabled: 'rgba(255, 255, 255, 0.30)',
    secondary: 'rgba(255, 255, 255, 0.70)',
    text: 'rgba(255, 255, 255, 1)'
  },
  Dark: {
    divider: 'rgba(0, 0, 0, 0.12)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    secondary: 'rgba(0, 0, 0, 0.54)',
    text: 'rgba(0, 0, 0, 0.87)'
  }
};

const themeColors = {
  Light: {
    statusBar: '#777777',
    appBar: '#E5E5E5',
    background: '#FAFAFA',
    card: '#FFFFFF'
  },
  Dark: {
    statusBar: '#000000',
    appBar: '#212121',
    background: '#303030',
    card: '#424242'
  }
};

export const Colors = materialColors;
export const Text = textColors;
export const Theme = themeColors;



// WEBPACK FOOTER //
// ./src/js/components/Material/Styles/Colors.js